<template>
<div class="dashboard">
  <div class="dashboard-container">

    <el-result title="提交成功，等待馆员审核入藏" :sub-title="subtitle">
      <template slot="icon">

        <img src="@/assets/submit.png" alt="404">

      </template>
    </el-result>
    <el-divider style="" direction="horizontal" content-position="center">您可以</el-divider>

    <div style="  text-align: center;">
      <el-button type="primary" size="medium" @click="nextUpload">再发一条</el-button>
      <el-button type="primary" size="medium" @click="closePage">关闭</el-button>
    </div>
  </div>
</div>
</template>

<script>
import {
  collectiongetById
} from '@/api/library'

export default {
  data() {
    return {
      subtitle: '馆藏编号CQU96189161651'
    }
  },
  mounted() {
    this.collectiongetById()
  },
  methods: {
    async collectiongetById() {
      const res = await collectiongetById({
        ids: this.$route.query.collectionId
      })
      if (res.data) {
        this.subtitle = '馆藏编号' + res.data[0].collectionId
      }
    },
    closePage() {
      const routeData = this.$router.resolve({
        name: 'Home'
      })
      window.open(routeData.href, '_self').close()
    },
    nextUpload() {
      this.$emit('uploadNext')
    }

  }

}
</script>

<style lang="scss" scoped>
::v-deep .el-result__title p {
  margin: 0;
  font-size: 20px;
  color: #4c70e8;
  font-weight: bold;
  line-height: 1.3;

}

.btn {
  width: 100px;
  height: 30px;
  background: #4C70E8;
  border-radius: 5px;
  font-weight: bold;
  font-size: 12px;
  padding: 0px;
}

.row {
  flex-direction: row;
  display: flex;
  align-items: center;

  &-img {
    opacity: 0.5;
  }

  &-img:hover {
    opacity: 1;
  }
}

.rowright {
  display: flex;
  position: fixed;
  top: 200px;
  width: 100px;
  flex-direction: column;

  &-contain {
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: center;
    padding-left: 10px;
    height: 30px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #b7bccd;
    cursor: pointer;
  }

  &-btn {
    font-size: 12px;
    width: 100px;
    color: #FEFEFE;

  }

  &-next {

    padding: 0px;
    margin: 0px;
    font-size: 18px;
    font-weight: bold;
    color: #FEFEFE;
  }
}

.dashboard {
  margin: auto;
  padding-top: 51px;
  width: 1140px;
  flex-direction: row;
  display: flex;
  box-sizing: border-box;

  &-container {
    width: 100%;
    padding: 20px;
    border-radius: 5px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  &-toplayout {
    display: flex;
    // flex-direction: row-reverse;
    margin: 0px 0px 10px 0px;
    align-items: center;
    justify-content: space-between;
    color: #000;
    font-size: 14px;
    line-height: 25px;

    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-space {
      display: flex;
      align-items: center;
      padding-left: 10px;
      padding-right: 11px;
      justify-content: space-between;
    }

    &-mgright {
      margin-right: 11px;

      font-size: 12px;
      line-height: 24px;
      color: #1F233E;

    }

    &-num {
      width: 24px;
      height: 24px;
      font-size: 12px;
      margin-right: 11px;
      // line-height: 24px;
      color: #ffff;
      display: flex;
      justify-content: center;
      background: #7B84A1;
      border-radius: 5px;
    }

    &-btn {
      margin-right: 15px;
      height: 24px;
      width: 176px;
      background: #7B84A1;
      border-radius: 5px;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 24px;
    }

    &-ftsbig {

      font-size: 20px;
      font-weight: bold;
      color: #4C70E8;

    }

    &-ftsnomal {
      margin-left: -25px;
      font-size: 12px;
      color: #1F233E;
      line-height: 24px;

    }
  }
}

// .dashboard {
//   margin: auto;
//   padding-top: 90px;
//  width: 1240px;
//   flex-direction: row;
//   display: flex;
//   box-sizing: border-box;

//   &-container {
//     margin-left: 20px;
//     padding: 30px;
//     width: 100%;
//     border-radius: 5px;
//     margin-top: 20px;
//     background-color: #fff;
//     box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
//   }

//   &-toplayout {
//     display: flex;
//     // flex-direction: row-reverse;
//     margin: 0px 0px 10px 0px;
//     align-items: center;
//     justify-content: space-between;
//     color: #000;
//     font-size: 14px;
//     line-height: 25px;

//     &-mgright {
//       margin-right: 15px;
//     }

//     &-ftsbig {
//       font-size: 25px;
//       line-height: 30px;
//       font-weight: bold;
//       color: #4c70e8;
//     }

//     &-ftsnomal {
//       font-size: 16px;
//       line-height: 25px;
//       color: #000;
//     }
//   }
// }
</style>
